<div class="d-flex justify-content-between py-4">
  <app-mai-material-bottom-table
    [baseDataTableComponent]="dataSource"
    [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
    (changePage)="handlePageChange($event)"
    class="w-100"
  ></app-mai-material-bottom-table>
</div>
